import { render, staticRenderFns } from "./Ubah.vue?vue&type=template&id=5d1e87d2&"
import script from "./Ubah.vue?vue&type=script&lang=js&"
export * from "./Ubah.vue?vue&type=script&lang=js&"
import style0 from "./Ubah.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports